import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

import { initData } from './data.js'

const root = createRoot(document.getElementById('root'));

const renderApp = () => {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
};

// Initial render (fast FCP/LCP for static sections like Hero)
renderApp();

// Fetch data and trigger a re-render for dynamic sections
initData().then(() => {
  renderApp();
});
